import { useIntl } from '@capsicum/common';
import { Alert, Text } from '@capsicum/common-web';
import { AlertIcon } from '@capsicum/common-web/icons';
import { useNCWBalance } from '@capsicum/socios-core';
import Link from 'next/link';
import { type ReactNode } from 'react';
import styled from 'styled-components';

import { NCWTestBeforeSendAlert } from '../../../ui';

export type SendTokensAlertProps = {
	alertType: 'message' | 'warning';
};

export const SendTokensAlert = ({ alertType }: SendTokensAlertProps) => {
	const { $t } = useIntl();
	const { chilizBalance } = useNCWBalance();

	if (alertType === 'message') {
		return <NCWTestBeforeSendAlert />;
	}

	// The error message including the link for the Alert of Warning type
	const tokenError = $t('ncWallet.send.enterAmount.tokenErrorSubtitle', {
		chilizBalance: chilizBalance?.tokenCardData.usableFormattedDefaultBalance,
		link: (chunks: Array<ReactNode>) => (
			<Link data-testid="ncw-send-tokenAmount-error-link" href="/nc-wallet/receive">
				<S.LinkText boxless variant="text4">
					{chunks}
				</S.LinkText>
			</Link>
		)
	});

	return (
		<Alert
			closable={false}
			icon={AlertIcon}
			subTitle={tokenError}
			title={$t('ncWallet.send.enterAmount.tokenErrorTitle')}
			type="warning"
		/>
	);
};

namespace S {
	export const LinkText = styled(Text)`
		color: ${({ theme }) => theme.colors.text.brand.enabled};
	`;
}
